import { render, staticRenderFns } from "./PopupEditGallery.vue?vue&type=template&id=3bf649d4&scoped=true&"
import script from "./PopupEditGallery.vue?vue&type=script&lang=js&"
export * from "./PopupEditGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf649d4",
  null
  
)

export default component.exports